import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SettingsComponent } from "./settings.component";
import { CalculationsComponent } from "./calculations/calculations.component";
import { CalculationComponent } from "./calculations/calculation/calculation.component";
import { AdminAuthGuard } from "./auth.guard";
import { CalcPlanEditorComponent } from "./calc-plan-editor/calc-plan-editor.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CalcInputComponent } from "./calc-plan-editor/calc-input/calc-input.component";
import { SharedModule } from "../../shared/shared.module";
import { CalcSourceQuestionComponent } from "./calc-plan-editor/calc-source-question/calc-source-question.component";
import { QuestionsComponent } from "./questions/questions.component";
import { TextTruncateDirective } from "./questions/text-truncate.directive";
import { QuestionComponent } from "./questions/question/question.component";
import { QuestionsResolver } from "./questions/questions-resolver";
import { QuestionTypePipe } from "./questions/question-type.pipe";
import { TaxReturnBuilderComponent } from "./tax-return-builder/tax-return-builder.component";
import { TaxYearsComponent } from "./tax-years/tax-years.component";
import { TaxReturnTypesComponent } from "./tax-return-types/tax-return-types.component";
import { AddUpdateTaxReturnTypeComponent } from "./tax-return-types/add-update-tax-return-type/add-update-tax-return-type.component";
import { TaxReturnSubTypesComponent } from "./tax-return-types/tax-return-subtypes/tax-return-subtypes.component";
import { AddUpdateTaxReturnSubTypeComponent } from "./tax-return-types/tax-return-subtypes/add-update-tax-return-subtype/add-update-tax-return-subtype.component";
import { TaxReturnBuilderSelectorComponent } from "./tax-return-builder/tax-return-builder-selector/tax-return-builder-selector.component";
import { ClientRulesQuestionsComponent } from "./client-rules/questions/client-rules-questions.component";
import { ClientRulesQuestionComponent } from "./client-rules/questions/question/client-rules-question.component";
import { ClientRulesQuestionsResolver } from "./client-rules/questions/client-rules-questions-resolver";
import { ClientRulesBuilderYearSelectComponent } from "./client-rules/client-rules-builder/year-select/client-rules-builder-year-select.component";
import { ClientRulesBuilderComponent } from "./client-rules/client-rules-builder/client-rules-builder.component";
import { GlobalQuestionsComponent } from "./global/questions/global-questions.component";
import { GlobalQuestionComponent } from "./global/questions/question/global-question.component";
import { GlobalQuestionsResolver } from "./global/questions/global-questions-resolver";
import { GlobalBuilderComponent } from "./global/builder/global-builder.component";
import { CountriesComponent } from "./countries/countries.component";
import { UsersComponent } from "./users/users.component";
import { AddUpdateCountryComponent } from "./countries/add-update-country/add-update-country.component";
import { SourcesComponent } from "./sources/sources.component";
import { SourceComponent } from "./sources/source/source.component";
import { SettingsRoutingModule } from "./settings-routing.module";
import { TaxReturnBuilderService } from "./tax-return-builder/tax-return-builder.service";
import { GlobalBuilderService } from "./global/builder/global-builder.service";
import { TemplatesComponent } from "./templates/templates.component";
import { NgClickOutsideDirective, NgClickOutsideDelayOutsideDirective } from 'ng-click-outside2';
import { UpdateTemplateTypeComponent } from "./templates/update-template-type/update-template-type.component"
import { MatDialogModule } from "@angular/material/dialog";
import { MatSelectModule } from "@angular/material/select";
import { MatMenuModule } from "@angular/material/menu";
import { ManageUserComponent } from "./users/manage-user/manage-user.component";
import { ConfigImportComponent } from './config-import/config-import.component';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { SmartFormSelectComponent } from "./smart-forms/smart-form-select/smart-form-select.component";
import { SmartFormTypesComponent } from "./smart-forms/types/smart-form-types.component";
import { SmartFormBuilderComponent } from "./smart-forms/smart-form-builder.component";
import { AddUpdateSmartFormTypeComponent } from "./smart-forms/types/add-update-smart-form-type/add-update-smart-form-type.component";
import { ReOrderableListComponent } from "./smart-forms/reorderable-list.directive";
import { SmartFormLogicEditor } from "./smart-forms/smart-form-logic/smart-form-logic-component";
import { SmartFormLogicCard } from "./smart-forms/smart-form-logic/logic-item-card/smartFormLogic-card.component";
import { AtlasImportComponent } from './atlas-import/atlas-import.component';
import { ArchivedConfigsComponent } from "./archived-configs/archived-configs.component";
import { FolderViewModule } from "../tax-returns/tax-return/rubix-documents/folder-view/folder-view.module";
import { NavigationModule } from "../tax-returns/tax-return/rubix-documents/navigation/navbar.module";
import {DragDropModule} from "@angular/cdk/drag-drop";
import { MatIconModule } from "@angular/material/icon";
import { DialogTitleComponent } from "../../shared/components/dialog-title/dialog-title.component";

@NgModule({
  imports: [
    CommonModule,
    SettingsRoutingModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgClickOutsideDirective,
    NgClickOutsideDelayOutsideDirective,
    MatDialogModule,
    MatSelectModule,
    MatIconModule,
    MatMenuModule,
    TranslocoModule,
    TranslocoModule,
    FolderViewModule,
    NavigationModule,
    DialogTitleComponent,
  ],
  providers: [
    AdminAuthGuard,
    QuestionsResolver,
    ClientRulesQuestionsResolver,
    GlobalQuestionsResolver,
    TaxReturnBuilderService,
    GlobalBuilderService,
    { provide: TRANSLOCO_SCOPE, useValue: 'settings' },
    { provide: TRANSLOCO_SCOPE, useValue: 'smart-forms' }
  ],
  exports: [],
  declarations: [
    SettingsComponent,
    CalculationsComponent,
    CalculationComponent,
    CalcPlanEditorComponent,
    CalcInputComponent,
    CalcSourceQuestionComponent,
    QuestionsComponent,
    TextTruncateDirective,
    QuestionComponent,
    QuestionTypePipe,
    TaxReturnBuilderComponent,
    ClientRulesBuilderYearSelectComponent,
    ClientRulesBuilderComponent,
    TaxYearsComponent,
    TaxReturnTypesComponent,
    AddUpdateTaxReturnTypeComponent,
    TaxReturnSubTypesComponent,
    AddUpdateTaxReturnSubTypeComponent,
    TaxReturnBuilderSelectorComponent,
    ClientRulesQuestionsComponent,
    ClientRulesQuestionComponent,
    GlobalBuilderComponent,
    GlobalQuestionsComponent,
    GlobalQuestionComponent,
    SourcesComponent,
    SourceComponent,
    TemplatesComponent,
    UpdateTemplateTypeComponent,
    CountriesComponent,
    AddUpdateCountryComponent,
    UsersComponent,
    ManageUserComponent,
    ConfigImportComponent,
    SmartFormSelectComponent,
    SmartFormTypesComponent,
    SmartFormBuilderComponent,
    SmartFormLogicEditor,
    SmartFormLogicCard,
    AddUpdateSmartFormTypeComponent,
    ReOrderableListComponent,
    ConfigImportComponent,
    AtlasImportComponent,
    ArchivedConfigsComponent
  ]
})
export class SettingsModule {}
